export const downloadFile = async (url: string, name?: string) => {
  const response = await fetch(url)
  const blob = await response.blob()
  return new File([blob], name || 'filename', { type: blob.type })
}
